import React from 'react'
import setClass from 'classnames'

const Tag = props => {
  const classNames = setClass('tag', 'is-info', {
    'app-is-clickable': props.isClickable
  })
  return <span className={classNames} onClick={props.onClick}>{props.text}</span>
}

export default Tag



// WEBPACK FOOTER //
// ./src/components/generic/Tag.js